export const siteConfig = {
  brandName: "Inuvella",
  announcement: "Join our paper-loving list for 10% off",
  logo: {
    text: "Inuvella",
    image: "/favicon.svg",
    alt: "Inuvella",
  },
  description:
    "Thoughtful paper goods and playful keepsakes made for celebrating everyday connections.",
  contact: {
    email: "debit@inuvella.xyz",
    address: "Annapolis, Maryland, USA",
  },
  locale: "en-US",
  currency: "USD",
  shipping: {
    freeThreshold: 50,
    standardRate: 5,
  },
  returns: {
    windowDays: 30,
  },
};

export const shopCategories = [
  "Greeting Cards",
  "Pocket Notes",
  "Notepads",
  "Stickers",
  "Gifts & Keepsakes",
];

const currencyFormatter = new Intl.NumberFormat(siteConfig.locale, {
  style: "currency",
  currency: siteConfig.currency,
});

export const formatCurrency = (value) => {
  const amount = typeof value === "number" ? value : Number(value);
  return currencyFormatter.format(Number.isFinite(amount) ? amount : 0);
};

const productData = [
  {
    id: 1,
    name: "Birthday Wishes Scratch-Off Card",
    category: "Greeting Cards",
    price: 7.5,
    images: ["/img/birthday-wishes-scratch-off-card.jpg"],
    description:
      "A cheerful birthday card with three silver scratch-off spots hiding tiny wishes for a bright year ahead.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "FSC-certified 120 lb cover",
      finish: "Matte with silver scratch-off details",
      includes: "Coral envelope",
    },
    tags: ["birthday", "interactive", "scratch-off", "bestseller", "new"],
  },
  {
    id: 2,
    name: "Big Hug Pop-Up Card",
    category: "Greeting Cards",
    price: 8.5,
    images: ["/img/big-hug-pop-up-card.jpg"],
    description:
      "Open this warm little card to reveal a dimensional paper hug, ready to travel across any distance.",
    attributes: {
      format: "A2 pop-up card",
      dimensions: "4.25 × 5.5 in",
      paper: "Recycled heavyweight cover",
      finish: "Die-cut dimensional insert",
      includes: "Lavender envelope",
    },
    tags: ["friendship", "love", "pop-up", "just because", "new"],
  },
  {
    id: 3,
    name: "Best Day Ever Confetti Card",
    category: "Greeting Cards",
    price: 6.5,
    images: ["/img/best-day-ever-confetti-card.jpg"],
    description:
      "Colorful illustrated confetti and a roomy blank interior make this an easy pick for every joyful milestone.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "FSC-certified 110 lb cover",
      finish: "Soft-touch matte",
      includes: "Sunshine yellow envelope",
    },
    tags: ["celebration", "birthday", "congratulations", "colorful"],
  },
  {
    id: 4,
    name: "You’re My Favorite Reveal Wheel Card",
    category: "Greeting Cards",
    price: 8,
    images: ["/img/youre-my-favorite-reveal-wheel-card.jpg"],
    description:
      "Turn the paper wheel to cycle through four sweet reasons someone is your absolute favorite.",
    attributes: {
      format: "A2 interactive wheel card",
      dimensions: "4.25 × 5.5 in",
      paper: "Premium 120 lb cover",
      finish: "Brass brad reveal wheel",
      includes: "Blush envelope",
    },
    tags: ["anniversary", "valentine", "interactive", "love"],
  },
  {
    id: 5,
    name: "New Adventure Graduation Card",
    category: "Greeting Cards",
    price: 6.5,
    images: ["/img/new-adventure-graduation-card.jpg"],
    description:
      "A spirited send-off for the graduate stepping into a brand-new chapter, illustrated with optimistic little icons.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "FSC-certified 110 lb cover",
      finish: "Matte with gold foil accents",
      includes: "Cobalt envelope",
    },
    tags: ["graduation", "congratulations", "new beginnings", "foil"],
  },
  {
    id: 6,
    name: "Tiny Miracle Welcome Baby Card",
    category: "Greeting Cards",
    price: 6.5,
    images: ["/img/tiny-miracle-welcome-baby-card.jpg"],
    description:
      "Soft watercolor stars surround a gentle welcome for a new little person and their very proud family.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "Cotton-blend 118 lb cover",
      finish: "Textured matte",
      includes: "Sage envelope",
    },
    tags: ["new baby", "family", "welcome", "watercolor"],
  },
  {
    id: 7,
    name: "Cheers to You Celebration Card",
    category: "Greeting Cards",
    price: 6,
    images: ["/img/cheers-to-you-celebration-card.jpg"],
    description:
      "Clinking glasses and dancing bubbles set a festive mood for promotions, engagements, birthdays, and big wins.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "FSC-certified 110 lb cover",
      finish: "Matte with spot gloss",
      includes: "Mint envelope",
    },
    tags: ["celebration", "engagement", "promotion", "congratulations"],
  },
  {
    id: 8,
    name: "Just Because Sunshine Card",
    category: "Greeting Cards",
    price: 5.5,
    images: ["/img/just-because-sunshine-card.jpg"],
    description:
      "A sunny, no-occasion-needed note designed to brighten a mailbox and make an ordinary day feel special.",
    attributes: {
      format: "A2 folded card",
      dimensions: "4.25 × 5.5 in",
      paper: "Recycled 100 lb cover",
      finish: "Uncoated matte",
      includes: "Sky blue envelope",
    },
    tags: ["just because", "encouragement", "friendship", "sunshine"],
  },
  {
    id: 9,
    name: "Little Love Notes Tin",
    category: "Pocket Notes",
    price: 16,
    images: ["/img/little-love-notes-tin.jpg"],
    description:
      "Thirty tiny cards tucked inside a reusable tin, perfect for leaving affectionate surprises in unexpected places.",
    attributes: {
      contents: "30 mini note cards",
      dimensions: "2.5 × 3.5 in each",
      paper: "FSC-certified writing stock",
      packaging: "Reusable illustrated metal tin",
      interior: "Blank",
    },
    tags: ["love notes", "mini cards", "giftable", "reusable tin"],
  },
  {
    id: 10,
    name: "Lunchbox High-Five Notes",
    category: "Pocket Notes",
    price: 12,
    images: ["/img/lunchbox-high-five-notes.jpg"],
    description:
      "A stack of upbeat mini messages made for lunchboxes, backpacks, coat pockets, and everyday encouragement.",
    attributes: {
      contents: "40 tear-off notes",
      dimensions: "3 × 3 in",
      paper: "Smooth 80 lb text stock",
      printing: "Full color on front and back",
      interior: "Prompt plus writing space",
    },
    tags: ["kids", "encouragement", "lunchbox", "family", "new"],
  },
  {
    id: 11,
    name: "Pocket Pep Talk Cards",
    category: "Pocket Notes",
    price: 14,
    images: ["/img/pocket-pep-talk-cards.jpg"],
    description:
      "Twenty-four pocket-sized reminders with bright words for brave mornings, difficult afternoons, and fresh starts.",
    attributes: {
      contents: "24 double-sided cards",
      dimensions: "2.25 × 3.25 in",
      paper: "Heavyweight recycled stock",
      packaging: "Paper drawer box",
      finish: "Rounded corners",
    },
    tags: ["affirmations", "encouragement", "self care", "giftable"],
  },
  {
    id: 12,
    name: "Everyday Gratitude Mini Notes",
    category: "Pocket Notes",
    price: 13,
    images: ["/img/everyday-gratitude-mini-notes.jpg"],
    description:
      "Simple fill-in prompts make it easy to notice good things and share sincere thanks in a few meaningful words.",
    attributes: {
      contents: "36 mini cards",
      dimensions: "3 × 4 in",
      paper: "Warm-white uncoated stock",
      packaging: "Recyclable belly band",
      interior: "Six rotating gratitude prompts",
    },
    tags: ["gratitude", "thank you", "mindfulness", "mini cards"],
  },
  {
    id: 13,
    name: "Today’s Bright Ideas Desk Pad",
    category: "Notepads",
    price: 18,
    images: ["/img/todays-bright-ideas-desk-pad.jpg"],
    description:
      "A generous desktop pad that gathers priorities, ideas, appointments, and a small bright spot for the day.",
    attributes: {
      sheets: "50 tear-off sheets",
      dimensions: "11 × 8.5 in",
      paper: "70 lb smooth writing paper",
      binding: "Glue-bound top edge",
      backing: "Rigid recycled chipboard",
    },
    tags: ["desk pad", "productivity", "daily planner", "work"],
  },
  {
    id: 14,
    name: "Happy Little List Notepad",
    category: "Notepads",
    price: 10,
    images: ["/img/happy-little-list-notepad.jpg"],
    description:
      "A slim, colorful list pad for errands, ideas, reminders, and all the tiny things worth remembering.",
    attributes: {
      sheets: "60 tear-off sheets",
      dimensions: "4 × 8 in",
      paper: "70 lb uncoated writing paper",
      binding: "Glue-bound top edge",
      backing: "Recycled chipboard",
    },
    tags: ["to do", "list pad", "organization", "colorful"],
  },
  {
    id: 15,
    name: "Market Morning Grocery Pad",
    category: "Notepads",
    price: 11,
    images: ["/img/market-morning-grocery-pad.jpg"],
    description:
      "Organized grocery sections and a tear-away meal idea strip keep market trips calm, quick, and cheerful.",
    attributes: {
      sheets: "50 tear-off sheets",
      dimensions: "5.5 × 8.5 in",
      paper: "70 lb recycled writing paper",
      layout: "Six grocery categories",
      backing: "Magnetic chipboard back",
    },
    tags: ["grocery", "meal planning", "kitchen", "magnetic"],
  },
  {
    id: 16,
    name: "Weekly Bloom Planner Pad",
    category: "Notepads",
    price: 17,
    images: ["/img/weekly-bloom-planner-pad.jpg"],
    description:
      "An undated floral weekly view with space for plans, priorities, meals, and one thing to look forward to.",
    attributes: {
      sheets: "52 undated sheets",
      dimensions: "10 × 7 in",
      paper: "80 lb fountain-pen-friendly stock",
      layout: "Monday through Sunday",
      backing: "Rigid recycled chipboard",
    },
    tags: ["weekly planner", "undated", "floral", "organization"],
  },
  {
    id: 17,
    name: "Small Wins Habit Tracker Pad",
    category: "Notepads",
    price: 12,
    images: ["/img/small-wins-habit-tracker-pad.jpg"],
    description:
      "A friendly four-week tracker that favors steady progress, flexible goals, and celebrating the smallest wins.",
    attributes: {
      sheets: "40 tear-off sheets",
      dimensions: "6 × 8 in",
      paper: "70 lb smooth writing paper",
      layout: "Four-week habit grid",
      backing: "Recycled chipboard",
    },
    tags: ["habit tracker", "wellness", "goals", "self care"],
  },
  {
    id: 18,
    name: "Good Mood Vinyl Sticker Sheet",
    category: "Stickers",
    price: 6,
    images: ["/img/good-mood-vinyl-sticker-sheet.jpg"],
    description:
      "A lively sheet of smiling suns, rainbows, flowers, and kind words for bottles, laptops, and notebooks.",
    attributes: {
      contents: "18 kiss-cut stickers",
      sheetSize: "5 × 7 in",
      material: "Weather-resistant matte vinyl",
      finish: "Soft-touch laminate",
      use: "Indoor and outdoor",
    },
    tags: ["vinyl", "rainbows", "positive", "water resistant", "new"],
  },
  {
    id: 19,
    name: "Garden Party Planner Stickers",
    category: "Stickers",
    price: 7,
    images: ["/img/garden-party-planner-stickers.jpg"],
    description:
      "Tiny florals, reminders, banners, and icons bring a soft garden-party rhythm to calendars and journals.",
    attributes: {
      contents: "Two sticker sheets, 72 stickers total",
      sheetSize: "4 × 6 in each",
      material: "Writable matte paper",
      finish: "Kiss-cut",
      use: "Planners and journals",
    },
    tags: ["planner stickers", "floral", "journaling", "organization", "sale"],
  },
  {
    id: 20,
    name: "Tiny Celebrations Seal Stickers",
    category: "Stickers",
    price: 5,
    images: ["/img/tiny-celebrations-seal-stickers.jpg"],
    description:
      "Bright little seals turn envelopes, wrapped parcels, and everyday notes into miniature celebrations.",
    attributes: {
      contents: "36 round stickers",
      stickerSize: "1.25 in diameter",
      material: "FSC-certified matte paper",
      finish: "Gold foil details",
      use: "Envelopes and gift wrap",
    },
    tags: ["envelope seals", "gift wrap", "celebration", "foil", "sale"],
  },
  {
    id: 21,
    name: "Cozy Correspondence Sticker Set",
    category: "Stickers",
    price: 8,
    images: ["/img/cozy-correspondence-sticker-set.jpg"],
    description:
      "Mailboxes, mugs, stamps, pens, and paper stacks make this illustrated set a treat for happy-mail fans.",
    attributes: {
      contents: "12 die-cut stickers",
      averageSize: "1.5–2.5 in",
      material: "Durable matte vinyl",
      finish: "Clear protective laminate",
      packaging: "Recyclable glassine envelope",
    },
    tags: ["happy mail", "stationery", "vinyl", "pen pals"],
  },
  {
    id: 22,
    name: "Reasons You’re Wonderful Keepsake Box",
    category: "Gifts & Keepsakes",
    price: 28,
    images: ["/img/reasons-youre-wonderful-keepsake-box.jpg"],
    description:
      "Fill fifty prompt cards with favorite memories, admirable quirks, and all the reasons one person means so much.",
    attributes: {
      contents: "50 prompt cards and keepsake box",
      cardSize: "3 × 4 in",
      material: "Heavyweight uncoated paper",
      packaging: "Rigid book-style box",
      finish: "Cloth pull tab and foil title",
    },
    tags: ["keepsake", "love", "memory gift", "anniversary"],
  },
  {
    id: 23,
    name: "Our Favorite Moments Memory Deck",
    category: "Gifts & Keepsakes",
    price: 24,
    images: ["/img/our-favorite-moments-memory-deck.jpg"],
    description:
      "A guided deck of story prompts for recording the funny, tender, and wonderfully ordinary moments shared together.",
    attributes: {
      contents: "40 guided memory cards",
      cardSize: "4 × 6 in",
      material: "Archival-quality card stock",
      packaging: "Two-piece illustrated box",
      finish: "Rounded corners",
    },
    tags: ["memories", "family", "couples", "storytelling"],
  },
  {
    id: 24,
    name: "Make a Wish Message Capsule",
    category: "Gifts & Keepsakes",
    price: 22,
    images: ["/img/make-a-wish-message-capsule.jpg"],
    description:
      "A small glass keepsake filled with colorful paper stars, each ready to hold a hope, promise, or tiny wish.",
    attributes: {
      contents: "40 foldable wish papers",
      vessel: "Reusable glass jar with cork lid",
      dimensions: "3 × 5 in",
      paper: "Assorted acid-free colors",
      packaging: "Recyclable gift box",
    },
    tags: ["wishes", "keepsake", "interactive gift", "celebration"],
  },
];

export default productData;
